const config = {
  BACKEND_URL:"https://cloud.xtranssolutions.com/api/",
  FLASK_URL: "https://cloud.xtranssolutions.com/ml/"
};

export default config; 
 //export const server = "https://cloud.xtranssolutions.com/api/";
// export const server = "http://74.208.151.248:4001/";
//export const server = "https://xtrans-solutions.onrender.com/";

